const workspaceConfig = {
    ip: process.env.NEXT_PUBLIC_ACKO_DRIVE_WORKSPACE,
    internal_ip: process.env.ACKO_DRIVE_WORKSPACE_SERVER,
};

export default workspaceConfig;